import React, { useEffect, useState, useRef } from 'react';
import Requests from 'http/Requests';

import clsx from 'clsx';
import CloseIcon from 'assets/images/icons/close.svg';

import { number, bool, func, string } from 'prop-types';
import useStore from 'state/state';
import { UnselectHotpostsiniSignal } from 'components/PlayCanvas/Application/ApplicationControl';
import ProductHeader from './ProductHeader/ProductHeader';
import CopyUrlButton from './CopyUrlButton/CopyUrlButton';
import ProductInfo from './ProductIInfo/ProductInfo';
import styles from './ProductPanel.module.scss';
import Sections from './Sections/Sections';
import Media from './Media/Media';

const ProductPanel = ({
  productId,
  productType,
  animateOut,
  setAnimateOut,
}) => {
  const [descriptionExpanded, setDescriptionExpand] = useState(false);
  const setProductObject = useStore((state) => state.setProductObject);
  const appData = useStore((state) => state.appData);
  const setProductData = useStore((state) => state.setProductData);
  const productData = useStore((state) => state.productData);
  const isOffline = useStore((state) => state.isOffline);
  const bottomPanelRef = useRef();
  const sectionsRef = useRef();
  const [whitePaperSlided, setWhitePaperSlided] = useState(false);

  const [showMoreLabel, setShowMoreLabel] = useState(
    appData.mainData.overallApp.readMoreText
  );
  const closeProduct = () => {
    setAnimateOut(true);
    setTimeout(() => {
      window.location = '#';
      setProductObject(null);
      setProductData(null);
      UnselectHotpostsiniSignal.dispatch();
      setAnimateOut(false);
    }, 1000);
  };

  const onDescriptionExpandClick = () => {
    if (descriptionExpanded) {
      setShowMoreLabel(appData.mainData.overallApp.readMoreText);
      setDescriptionExpand(false);
    } else {
      bottomPanelRef.current.scrollTo(0, 0);
      setDescriptionExpand(true);
      setShowMoreLabel(appData.mainData.overallApp.readLessText);
    }
  };

  useEffect(() => {
    const onProductDataLoaded = (data) => {
      setProductData(data);
      window.location = `#${data.alias}`;
    };

    const loadProductData = () => {
      Requests.getProductDataById(
        productId,
        productType,
        onProductDataLoaded,
        appData
      );
    };

    if (!productData) {
      loadProductData(productId, productType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productData, productId, productType, setProductData]);

  const onScroll = () => {
    const bottomPanelYpos = bottomPanelRef.current.getBoundingClientRect().y;
    const sectionsYpos = sectionsRef.current.getBoundingClientRect().y;
    if (sectionsYpos < bottomPanelYpos) {
      setWhitePaperSlided(true);
    } else if (sectionsYpos > bottomPanelYpos) {
      setWhitePaperSlided(false);
    }
  };

  useEffect(() => {
    if (animateOut) {
      bottomPanelRef.current.removeEventListener('scroll', onScroll);
    } else {
      bottomPanelRef.current.addEventListener('scroll', onScroll);
    }
  }, [animateOut]);

  useEffect(() => {
    console.log('isOffline: ', isOffline);
    if (isOffline) {
      setDescriptionExpand(true);
      onDescriptionExpandClick();
    }
  }, []);

  return (
    <div
      style={{ pointerEvents: animateOut ? 'none' : 'all' }}
      className={styles.wrapper}
    >
      <div
        className={clsx(styles.panelContainer, {
          [styles.fadeOut]: animateOut,
        })}
      >
        <div className={clsx(styles.panel, styles.topPanel)}>
          {productData && productData.featured && (
            <div className={styles.featuredContainer}>
              <div className={styles.featured}>
                {appData.mainData.overallApp.featuredLabelText}
              </div>
            </div>
          )}
          <button
            className={clsx(styles.close, { [styles.fadeOut]: animateOut })}
            type="button"
            label="close"
            onClick={closeProduct}
          >
            <CloseIcon />
          </button>
          {productData && (
            <ProductHeader data={productData} animateOut={animateOut} />
          )}

          {productData && <CopyUrlButton animateOut={animateOut} />}
        </div>
        <div
          ref={bottomPanelRef}
          className={clsx(styles.bottomPanel, styles.panel, {
            [styles.infoExpanded]: descriptionExpanded,
          })}
        >
          {productData && (
            <ProductInfo
              data={productData}
              descriptionExpanded={descriptionExpanded}
              type={productType}
              animateOut={animateOut}
            />
          )}
          {!isOffline && (
            <button
              onClick={onDescriptionExpandClick}
              className={clsx(styles.showMore, {
                [styles.fadeOut]: animateOut,
              })}
              type="button"
            >
              {showMoreLabel}
            </button>
          )}
          <div className={styles.bottomContent}>
            {productData && !isOffline && (
              <div className={styles.test} ref={sectionsRef}>
                <Sections
                  data={productData}
                  animateOut={animateOut}
                  whitePaperSlided={whitePaperSlided}
                />
                <Media data={productData.media} animateOut={animateOut} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

ProductPanel.propTypes = {
  productId: string.isRequired,
  productType: number.isRequired,
  animateOut: bool.isRequired,
  setAnimateOut: func.isRequired,
};

export default ProductPanel;
